<template>
  <!-- <b-card class="sa-card" header="" header-tag="header" footer-tag="footer" title=""> -->
  <!-- <b-tabs content-class="mt-3" class="sa-tab" style="height: 100%" fill> -->
  <!-- <b-tabs id="tabsMagazzino" ref="tabsMagazzino" v-model="activeTabIndex" content-class="mt-3" class="sa-tab" style="height: 100%; padding-bottom: 25px" fill @input="onInputTabs"> -->
  <b-tabs id="tabsMagazzino" ref="tabsMagazzino" v-model="activeTabIndex" nav-wrapper-class="sa-tab-items"
    content-class="mt-3" class="sa-tab" style="height: 100%; padding-bottom: 25px" fill @input="onInputTabs">
    <b-tab lazy>
      <template #title> <i class="fas fa-stream"></i><span style="padding-left: 10px">Anagrafica</span> </template>
      <component :is="currentAnagraficaComponent" @updateJsonData="onUpdateJsonData" @tipoArticolo="onTipoArticolo"
        @beforeLoadData="onBeforeLoadData" @afterLoadData="onAfterLoadData" ref="cmpMagazzinoArticoliAnagrafica" />
    </b-tab>
    <b-tab lazy v-if="!isNewArticolo">
      <template #title> <i class="fas fa-barcode"></i><span style="padding-left: 10px">Codici</span> </template>
      <magazzino-articoli-codici-lotto-matricole-list-component
        ref="cmpMagazzinoArticoliCodiciLottoMatricoleListComponent" />
    </b-tab>
    <b-tab v-if="isFarmaco" id="bancaFarmaci" lazy>
      <template #title> <i class="fas fa-book-medical"></i><span style="padding-left: 10px">Scheda Farmaco</span>
      </template>
      <banca-farmaci-view-component ref="cmpBancaFarmaciView" />
    </b-tab>
    <b-tab lazy v-if="!isNewArticolo">
      <template #title> <i class="fas fa-truck-moving"></i><span style="padding-left: 10px">Fornitori</span> </template>
      <magazzino-articoli-fornitori-list-component />
    </b-tab>
    <b-tab lazy v-if="!isNewArticolo">
      <template #title> <span style="padding-left: 10px">Allegati</span></template>
      <p>Tab Tre</p>
      aggiungere allegati
    </b-tab>
    <b-tab v-if="!isNewArticolo">
      <template #title><span style="padding-left: 10px">Storico
          Contabile</span></template>


      <MagazzinoArticoliListComponent :component="true" ref="cmpMagazzinoArticoliListComponent" />


      <!-- <magazzino-articoli-storico-contabile-component
        ref="cmpMagazzinoArticoliStoricoContabile"></magazzino-articoli-storico-contabile-component> -->
    </b-tab>
    <b-tab lazy v-if="!isNewArticolo">
      <template #title><i class="fa-solid fa-calendar"></i><span style="padding-left: 10px">Storico Giacenza</span>
      </template>
      <magazzino-articoli-storico-giacenze-component :visibleColumns="visibleColumnArray"
        ref="cmpMagazzinoArticoliStoricoGiacenzeComponent"></magazzino-articoli-storico-giacenze-component>
    </b-tab>
  </b-tabs>
  <!-- </b-card> -->
</template>

<script>
import MagazzinoArticoliAnagraficaEditComponent from "./MagazzinoArticoliAnagraficaEditComponent.vue";
import MagazzinoArticoliViewComponent from "./MagazzinoArticoliViewComponent.vue";
import MagazzinoArticoliFornitoriListComponent from "./MagazzinoArticoliFornitoriListComponent.vue";
import BancaFarmaciViewComponent from "../../bancafarmaci/components/BancaFarmaciViewComponent.vue";
import MagazzinoArticoliListComponent from "./MagazzinoArticoliListComponent.vue";
// import MagazzinoArticoliStoricoContabileComponent from "./MagazzinoArticoliStoricoContabileComponent.vue";
import MagazzinoArticoliStoricoGiacenzeComponent from "./MagazzinoArticoliStoricoGiacenzeComponent.vue";
import MagazzinoArticoliCodiciLottoMatricoleListComponent from "./MagazzinoArticoliCodiciLottoMatricoleListComponent.vue";
export default {
  name: "MagazzinoArticoliEditComponent",
  //MagazzinoArticoliStoricoContabileComponent
  components: { MagazzinoArticoliListComponent, MagazzinoArticoliStoricoGiacenzeComponent, MagazzinoArticoliCodiciLottoMatricoleListComponent, MagazzinoArticoliAnagraficaEditComponent, MagazzinoArticoliViewComponent, MagazzinoArticoliFornitoriListComponent, BancaFarmaciViewComponent },
  data() {
    return {
      activeTabIndex: 0,
      btnSaveVisible: true,
      showModalLoading: false,
      visibleColumnArray: ["documento", "prezzoUnitario", "quantita", "causaleDocumentoOperazioneMagazzino"],
      linkback: "/magazzino/articoli",
      pathResource: "/magazzinoarticoli",
      jsonData: null,
      isNewArticolo: false,
      isFarmaco: false,
      isView: false,
      codiceArticolo: null,
      id: null,
    };
  },
  computed: {
    // Determina quale componente usare basandosi sulla route
    currentAnagraficaComponent() {
      if (this.isView) {
        return "MagazzinoArticoliViewComponent";
      }
      return "MagazzinoArticoliAnagraficaEditComponent";
    },
  },
  created() { },
  mounted() {
    let me = this;
    me.isView = me.$route.path.includes("/view/");
    me.id = this.$route.params.id;
    if (me.id == null || me.id == '-1') {
      me.isNewArticolo = true;
    }
    else {
      me.isNewArticolo = false;
    }
  },

  methods: {
    onUpdateJsonData(jsonData) {
      let me = this;
      me.jsonData = jsonData;
      me.codiceArticolo = jsonData.codiceArticolo;
      me.$emit("updateJsonData", jsonData);
    },

    onTipoArticolo(farmaco) {
      let me = this;
      me.isFarmaco = farmaco;
    },
    /* onSalvaAnagraficaArticolo() {
            let me = this;
            me.$refs.cmpMagazzinoArticoliAnagraficaEdit.salvaAnagraficaArticolo();
        }, */

    onBeforeLoadData() {
      let me = this;
      me.$emit("beforeLoadData");
    },
    onAfterLoadData() {
      let me = this;
      me.$emit("afterLoadData");
    },
    onInputTabs() {
      let me = this;
      //let indexTab = me.$refs.tabsMagazzino.getTabs()[index];

      me.activeTab(me.activeTabIndex);
      /* console.log("index", index);
            console.log("indexTab", indexTab.id); */
    },
    activeTab(idIndexTab) {
      console.log(idIndexTab);
      if (this.isView) {
        if (this.isFarmaco) {
          if (idIndexTab == 5) {
            console.log("carica contabilita");
            this.$refs.cmpMagazzinoArticoliListComponent.init({ idArticolo: this.id })
            // this.$refs.cmpMagazzinoArticoliStoricoContabile.init({ idArticolo: this.id });
          }
          if (idIndexTab == 6) {
            this.$refs.cmpMagazzinoArticoliStoricoGiacenzeComponent.init({ idArticolo: this.id });
          }
        } else {
          if (idIndexTab == 4) {
            console.log("carica contabilita");
            //this.$refs.cmpMagazzinoArticoliStoricoContabile.init({ idArticolo: this.id });
          }
          if (idIndexTab == 5) {
            this.$refs.cmpMagazzinoArticoliStoricoGiacenzeComponent.init({ idArticolo: this.id });
          }
        }
      } else {
        if (idIndexTab == 3) {
          console.log("carica contabilita");
          // this.$refs.cmpMagazzinoArticoliStoricoContabile.init({ idArticolo: this.id });
        }
        if (idIndexTab == 4) {
          this.$refs.cmpMagazzinoArticoliStoricoGiacenzeComponent.init({ idArticolo: this.id });
        }
      }
    },
  },
};
</script>

<style></style>
